import React, { Component } from "react";

import Modal from "../Modal/Modal";
import Form from "../Form/Form";

class EditScrape extends Component {

    state = {
        scrapepage: this.props.scrapepage,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { scrapepage = '' } = this.state

        return (
            <Modal
                narrow
                extraClassName="EditSeedpage"
                onCancel={this.props.onClose}
                onSave={this.onSave}
                saveText="Save"
                mode="edit"
                title="Scrape">
                <Form>
                    <div>
                        <input
                            type="url"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            placeholder="Click 'Save' to start scrape"
                            value={scrapepage}
                            onChange={e => this.setState({ scrapepage: e.target.value })} />
                    </div>
                </Form>
            </Modal>
        )
    }
}
export default EditScrape;


// WEBPACK FOOTER //
// ./src/components/LBUs/EditScrape.js